import { useState } from 'react';
import { Button, Stack, TextField, Typography } from '@mui/material';
import { Link } from '../../components/global/Link';
import { useAuth } from '../../contexts/AuthContext';
import AssetRegisterLogo from '../../assets/images/logo.svg';
import { UserData, UserDataError } from '../../types';

export const Signup = () => {
  const [user, setUser] = useState<UserData>({});
  const { signUp } = useAuth();
  const [error, setError] = useState<UserDataError>({});

  const handleSignup = async () => {
    const { errors } = await signUp(user);
    if (errors) {
      setError(errors);
    } else {
      setError({});
    }
  };

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      height="100vh"
      minHeight="900px"
      paddingBottom={4}>
      <Stack sx={{ maxWidth: '500px', width: '100%' }} spacing={2}>
        <Stack width="100%" justifyContent="center" alignItems="center">
          <img src={AssetRegisterLogo} height={120} />
        </Stack>
        <Stack width="100%" justifyContent="center" alignItems="center" pt={4}>
          <Typography
            variant="h4"
            gutterBottom
            fontFamily="korolev-condensed"
            fontWeight="600"
            letterSpacing="1px">
            Sign Up
          </Typography>
          <Typography
            variant="body2"
            gutterBottom
            fontStyle="italic"
            color="#DA0101">
            {error.main}
          </Typography>
        </Stack>
        <Stack component="form" width="100%" spacing={4}>
          <Stack width="100%">
            <Typography>
              First Name <span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              variant="outlined"
              value={user.first_name}
              error={error.first_name ? true : false}
              helperText={error?.first_name?.[0] ?? ''}
              onChange={e => setUser({ ...user, first_name: e.target.value })}
            />
          </Stack>
          <Stack width="100%">
            <Typography>
              Last Name <span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              variant="outlined"
              value={user.last_name}
              error={error.last_name ? true : false}
              helperText={error?.last_name?.[0] ?? ''}
              onChange={e => setUser({ ...user, last_name: e.target.value })}
            />
          </Stack>
          <Stack width="100%">
            <Typography>Company Name</Typography>
            <TextField
              variant="outlined"
              value={user.company_name}
              error={error.company_name ? true : false}
              helperText={error?.company_name?.[0] ?? ''}
              onChange={e => setUser({ ...user, company_name: e.target.value })}
            />
          </Stack>
          <Stack width="100%">
            <Typography>
              Email Address <span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              variant="outlined"
              value={user.email}
              error={error.email ? true : false}
              helperText={error?.email?.[0] ?? ''}
              onChange={e => setUser({ ...user, email: e.target.value })}
            />
          </Stack>
          <Stack width="100%">
            <Typography>
              Password <span style={{ color: 'red' }}>*</span>
            </Typography>
            <TextField
              type="password"
              variant="outlined"
              value={user.password}
              error={error.password ? true : false}
              helperText={error?.password?.[0] ?? ''}
              onChange={e => setUser({ ...user, password: e.target.value })}
            />
          </Stack>
        </Stack>
        <Stack alignItems="center" justifyContent="center" pt={2}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={{ fontWeight: '900', textTransform: 'unset' }}
            onClick={handleSignup}>
            Sign Up
          </Button>
        </Stack>
        <Stack alignItems="center" justifyContent="center" pt={2}>
          <Typography textAlign="center" pt={1}>
            Already have an account?
            <Link to="/signin">
              <span>Signin here</span>
            </Link>
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
